module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_4.8eb05c78.mp4";